// shared-types/src/ai/types.ts - AI credits entity types

export enum AiCreditType {
    IMAGE = 'IMAGE',
    TEXT = 'TEXT',
}

export enum AiCreditSource {
    FREE = 'FREE',
    PAID = 'PAID',
}

export enum AiCreditTransactionReason {
    GENERATION = 'generation',
    MONTHLY_REFILL = 'monthly_refill',
    PURCHASE = 'purchase',
    MANUAL_ADJUSTMENT = 'manual_adjustment',
}

export interface AccountAiCredits {
    accountId: string
    monthlyFreeImageCredits: number
    paidImageCredits: number
    monthlyFreeTextCredits: number
    paidTextCredits: number
    lastMonthlyRefill: Date | null
    updatedAt: Date
}

export interface AccountAiCreditTransaction {
    id: string
    accountId: string
    type: AiCreditType
    amount: number
    source: AiCreditSource
    reason: AiCreditTransactionReason
    createdAt: Date
}

export interface AiCreditsBalance {
    imageCredits: number
    textCredits: number
}
